<ng-container *ngIf="!loading; else isLoading">
  <div class="form-group gw-relative gw-h-[72px] {{ class }}">
    <div class="gw-flex gw-flex-col gw-h-[{{ height }}]">
      <label
        class="gw-form-label gw-h-[16px]"
        *ngIf="label"
        [attr.for]="effectiveInputId"
        [class]="labelClass"
      >
        {{ label }}
        <span *ngIf="required" class="gw-text-status-negative">*</span>
      </label>

      <div class="gw-input-group gw-flex gw-flex-col gw-items-start">
        <tui-textfield
          [iconStart]="iconStart"
          tuiChevron
          tuiTextfieldSize="m"
          class="gw-w-full"
          [stringify]="stringify"
          [tuiTextfieldCleaner]="false"
        >
          <input
            [id]="effectiveInputId"
            [attr.name]="effectiveInputId"
            class="select-picker hover:gw-bg-background-neutral-1-hover"
            [placeholder]="placeholder"
            tuiSelect
            [disabled]="disabled"
            [ngModel]="value"
            [ngModelOptions]="{standalone: true}"
            (ngModelChange)="handleChange($event)"
            (blur)="markTouched()"
          />

          <button
            *ngIf="value"
            type="button"
            class="gw-absolute gw-h-[44px] gw-text-[12px] gw-right-[40px] gw-top-1/2 gw--translate-y-1/2 gw-text-text-secondary hover:gw-text-text-primary gw-transition-colors gw-duration-200 gw-cursor-pointer focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-border-focus focus:gw-ring-offset-1"
            (click)="clearValue()"
          >
            <i class="fa-solid fa-x"></i>
          </button>

          <tui-data-list-wrapper
            *tuiTextfieldDropdown
            new
            [items]="items"
            [itemContent]="itemContentTpl"
          />

          <tui-icon *ngIf="toolTip" [tuiTooltip]="toolTip" />
        </tui-textfield>
        <error-message
          *ngIf="control"
          [control]="control"
          [customMessages]="customMessages"
        ></error-message>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #itemContentTpl let-item>
  <span>{{ item?.label | translate }}</span>
</ng-template>

<ng-template #isLoading>
  <gatewee-skeleton></gatewee-skeleton>
</ng-template>
